var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('carousel',{attrs:{"data-list":_vm.dataList,"carousel-attrs":_vm.attrs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }